import { useMutation } from '@tanstack/react-query'
import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import { messages } from 'shared/utils'

export const MFA_MUTATIONS_KEYS = {
    SEND_OTP: 'send-otp',
    VERIFY_OTP: 'verify-otp'
}

export const sendCodeMutation = async (
    mfaToken: string
): Promise<?$Values<typeof messages>> => {
    delete ws.defaults.headers['Authorization']
    ws.defaults.headers['Authorization'] = `Bearer ${mfaToken}`
    const result = await ws.post(endpoints.kingdom.auth.sendOtp)

    return result.data
}

export const useSendCodeMutation = (options?: any) => {
    return useMutation({
        mutationKey: MFA_MUTATIONS_KEYS.SEND_OTP,
        mutationFn: sendCodeMutation,
        ...options
    })
}

const verifyCodeMutation = async ({
    mfaToken,
    code
}: {
    mfaToken: string,
    code: string
}) => {
    delete ws.defaults.headers['Authorization']
    ws.defaults.headers['Authorization'] = `Bearer ${mfaToken}`

    const result = await ws.post(endpoints.kingdom.auth.verifyOtp, { code })

    return result
}

export const useVerifyCodeMutation = (options?: any) => {
    return useMutation({
        mutationKey: MFA_MUTATIONS_KEYS.VERIFY_OTP,
        mutationFn: verifyCodeMutation,
        ...options
    })
}
